module.exports = __webpack_public_path__ + "img/icon-player.c517fd64.png";